export const getOptionsSelect = (options = [], isStage = false) => {
  return options?.map((option) => ({
    ...option,
    key: option.id,
    value: option.id,
    content: option.name || option.id,
    search: option.name || option.id,
    ...(isStage && { disabled: !option.available }),
  }));
};
